import * as React from 'react';
import { connect } from 'react-redux';
import { IPerformanceErrorMessage } from '../../../package-listing/classes/package-listing';
import { IPackageListingAppText } from '../../custom/classes/package-listing-text';
import { IZone } from '../../custom/classes/production';
import { getCartItemDetails, isUnseatedFromPerformanceSeatStatuses } from '../../helpers/cart-helpers';
import { IPackageListingAppState } from '../../redux-state';
import { removeItemFromCart, removeSelectedZone } from '../../redux-state/actions/package-listing.actions';
import CartItemView from '../../views/library/cart-item.view';


interface ICartItemExternalProps {
    itemId: number;
    selectedZoneId: number;
}

interface StateToProps {
    text: IPackageListingAppText;
    itemProcessErrorMessage: string;
    selectedZone: IZone;
    isUnseated: boolean;
    
    itemIdToRemove: number;
    itemTitle: string;
    itemFacility: string;
    itemDateString: string;
    itemTimeString: string;

    showRemoveButton: boolean;
}

interface DispatchToProps {
    removeItem: (itemId: number) => void;
    removeZone: (itemId: number) => void;
}

export type CartItemProps = ICartItemExternalProps & StateToProps & DispatchToProps;

export type CombineCartViewProps = CartItemProps;

export class FiltersBase extends React.Component<CartItemProps, any> {
    constructor(props: CartItemProps) {
        super(props);
    }

    render() {
        return <CartItemView {...this.props} {...this.state} />;
    }
}

function mapStateToProps(state: IPackageListingAppState, ownProps: ICartItemExternalProps): StateToProps {
    var perfMessage: Array<IPerformanceErrorMessage> = [];
    if (state.packageListing.errorMessages != undefined)
        perfMessage = state.packageListing.errorMessages.filter(err => err.performanceId === ownProps.itemId);
    var performancePricing = state.packageListing.performancePricingList
        .get(ownProps.itemId);

    var itemDetails = getCartItemDetails(state, ownProps.itemId);

    let venue = "";
    if (!state.packageListingText.hideVenues) {
        if (state.packageListingText.venueOverride != null) {
            if (state.packageListingText.venueOverride.trim() === "" || state.packageListingText.venueOverride === null) {
                venue = itemDetails.facility.facilityDescription
            } else {
                venue = state.packageListingText.venueOverride
            }
        }
    }
    

    if (!performancePricing) {
        performancePricing = state.packageListing.performancePricingList.get(itemDetails.itemIdToRemove);
    }

    let isUnseated = state.packageListingSettings.useUnseatedReservation;
    if (state.packageListing.isMixedFlexPackage && state.packageListing.cartItems.size > 0 && ownProps.itemId > 0) {
        isUnseated = isUnseatedFromPerformanceSeatStatuses(state, ownProps.itemId);
    }

    return {
        text: state.packageListingText,
        itemProcessErrorMessage: perfMessage.length > 0 ? perfMessage[0].errorMessage : "",
        selectedZone: performancePricing ? performancePricing.zones
            .filter(z => z.zone.id == ownProps.selectedZoneId)[0]
            : null,
        isUnseated: isUnseated,
        itemIdToRemove: itemDetails.itemIdToRemove,
        itemDateString: itemDetails.itemDate,
        itemTimeString: itemDetails.itemTime,
        itemFacility: venue,
        itemTitle: itemDetails.itemTitle,
        showRemoveButton: state.packageListing.packages.length !== 1
    }
}

function mapDispatchToProps(dispatch, ownProps: CartItemProps): DispatchToProps {
    return {
        removeItem: (itemId: number) => {
            dispatch(removeItemFromCart(itemId));

        },
        removeZone: (itemId: number) => {
            dispatch(removeSelectedZone(itemId));

        }
    }
}

export default connect<StateToProps, DispatchToProps>(mapStateToProps, mapDispatchToProps)(FiltersBase);